export const PAGE_TYPES = {
  MLB: "mlb",
  NFL: "nfl",
  NHL: "nhl",
  NBA: "nba",
};
